module.exports = __webpack_public_path__ + "img/guide_sheet.e1b9d409.png";